<template>
    <div>
        <div hidden id='inventoryDetailReport' class="col-md-7">
            <!--HEADER-->
            <div class="col-md-12" style="height:45mm;border:2px solid #000000;">
                <div class="row" style="height:35mm">
                    <div class="col-md-4 ">
                        <table class="text-left">
                            <tr>
                                <td>
                                    <p>
                                        <span style="font-size:25px;color:black !important;font-weight:bold;">{{headerFooters.company.nameEnglish}}</span><br />
                                        <span style="font-size:17px;color:black !important;font-weight:bold;">{{headerFooters.company.categoryEnglish}}</span><br />
                                        <span style="font-size:16px;color:black !important;font-weight:bold;">VAT No.: {{headerFooters.company.vatRegistrationNo}}</span><br />
                                        <span style="font-size:16px;color:black !important;font-weight:bold;">Cr No.:{{headerFooters.company.companyRegNo}}</span><br />
                                        <span style="font-size:15px;color:black !important;font-weight:bold;">
                                            Tel: {{headerFooters.company.phoneNo}}
                                        </span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-4 text-center my-5" style="padding:0px !important; margin:0 !important">
                        <img :src="headerFooters.company.logoPath" style="width:auto;max-width:300px; max-height:100px; padding:5px !important; margin:0 !important">
                    </div>
                    <div class="col-md-4 ">
                        <table class="text-right" v-if="arabic=='true'">
                            <tr>
                                <td>
                                    <p>
                                        <span style="font-size:25px;color:black !important;font-weight:bold;">{{headerFooters.company.nameArabic}}.</span><br />
                                        <span style="font-size:17px;color:black !important;font-weight:bold;">{{headerFooters.company.categoryArabic}}</span><br />
                                        <span style="font-size:16px;color:black !important;font-weight:bold;">رقم ضريبة القيمة المضافة: {{headerFooters.company.vatRegistrationNo}}</span><br />
                                        <span style="font-size:16px;color:black !important;font-weight:bold;">رقم السجل التجاري :{{headerFooters.company.companyRegNo}}</span><br />
                                        <span style="font-size:15px;color:black !important;font-weight:bold;">
                                            هاتف: {{headerFooters.company.phoneNo}}:
                                        </span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                
            </div>
          
            <!--INFORMATION-->
            <div class="border border-dark col-md-12  ">
                <div class="row m-3">
                    <div class="col-md-6" style="display:flex;">
                        <div style="width:28%; font-weight:bolder;text-align:right;color:black !important;">From Date:</div>
                        <div style="width:50%; text-align:center;font-weight:bold;color:black !important;">{{fDate}}</div>
                        <div style="width:22%;font-weight:bolder;color:black !important;font-size:15px !important" v-if="arabic=='true'">:من التاريخ</div>
                    </div>
                    <div class="col-md-6" style="display:flex;">
                        <div style="width:28%;font-weight:bolder;text-align:right;color:black !important;">To Date:</div>
                        <div style="width:50%;text-align:center;font-weight:bold;color:black !important;"><span>{{tDate}}</span> </div>
                        <div style="width:22%;font-weight:bolder;color:black !important; padding-right:20px;font-size:15px !important" v-if="arabic=='true'">
                            :حتي اليوم
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 ">
                <div class="row">

                    <table class="table col-md-12 m-auto">
                        <tr class="heading" style="font-size:14px;">
                            <th class="text-left">#</th>
                            <th class="text-left">{{ $t('TrialBalanceAccountReport.Code') }}</th>
                            <th class="text-left">{{ $t('TrialBalanceAccountReport.Name') }}</th>
                            <th class="text-left">{{ $t('TrialBalanceAccountReport.CostCenter') }}</th>
                            <th class="text-left">{{ $t('TrialBalanceAccountReport.AccountType') }}</th>
                            <th class="text-right">{{ $t('TrialBalanceAccountReport.Debit') }}</th>
                            <th class="text-right">{{ $t('TrialBalanceAccountReport.Credit') }}</th>
                            <th class="text-right">{{ $t('TrialBalanceAccountReport.Balance') }}</th>
                        </tr>
                        <tr style="font-size:13px; page-break-after: always;" v-for="(item, index) in transactionDetail" v-bind:key="index">
                            <td class="text-left">{{index+1}}</td>

                            <td class="text-left">{{item.accountCode}}</td>
                            <td class="text-left" v-if="item.accountName != ''">{{item.accountName}}</td>
                            <td class="text-left" v-else>{{item.accountNameArabic}}</td>
                            <td class="text-left">{{item.costCenter}}</td>
                            <td class="text-left">{{item.accountType}}</td>
                            <td class="text-right">
                                {{  nonNegative(item.debit)}}
                            </td>
                            <td class="text-right">
                                {{nonNegative(item.credit)}}
                            </td>
                            <td class="text-right">
                                {{item.total>0?'Dr':'Cr'}} {{nonNegative(item.total) }}
                            </td>
                        </tr>
                        <tr style="font-size:13px;">
                            <td class="text-right" colspan="5">
                                <h6>{{ $t('TrialBalanceAccountReport.Total') }}</h6>
                            </td>
                            <td class="text-right">
                                <h6>{{  getCreditTotal}}</h6>
                            </td>
                            <td class="text-right">
                                <h6>{{getDebitTotal}}</h6>
                            </td>
                            <td class="text-right">
                                <h6> {{getLineTotal>0?'Dr':'Cr'}} {{getLineTotal }}</h6>
                            </td>
                        </tr>

                    </table>
                   
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import moment from "moment";
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        props: ['printDetails', 'isShown', 'formName', 'isPrint', 'dates', 'headerFooter', 'fromDate', 'toDate',''],
        data: function () {
            return {
                transactionDetail:[],
                fDate: '',
                tDate: '',
                headerFooters: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                Print: false,
                render: 0,
                arabic: '',
                english: '',
            }
        },
        mounted: function () {

            this.fDate = this.fromDate;
            this.tDate = this.toDate;
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.isHeaderFooter = localStorage.getItem('IsHeaderFooter');
            var root = this;

            this.headerFooters = this.headerFooter
            root.Print = root.isPrint;
            if (this.printDetails.length > 0 && root.Print) {

                this.transactionDetail = this.printDetails;
                setTimeout(function () {
                    root.printInvoice();
                }, 125)
            }
        },
        computed: {
            getCreditTotal: function () {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.credit;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            getDebitTotal: function () {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.debit;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            getLineTotal: function () {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.total;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            }
        },
        methods: {
            nonNegative: function (value) {
                return parseFloat(Math.abs(value)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            convertDate: function (x) {
                return moment(x).format('DD MMM YYYY');
            },
            printInvoice: function () {
                this.$htmlToPaper('inventoryDetailReport');
            }
        }
    }
</script>


<style scoped>
    #font11 {
        font-size: 11px;
        line-height: 0;
    }

    #font16 {
        font-size: 16px;
    }
</style>